import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge has to be told about the app's type roles (globals.css `--text-*`). Out of the
 * box it reads `text-caption` as a COLOUR, because it is not one of Tailwind's own size names —
 * so `cn("text-caption text-stone-600")` dropped the size and `cn("text-primary-foreground
 * text-small")` dropped the colour, everywhere at once. Keep this list in step with
 * the scale in globals.css; lib/utils.test.ts proves it.
 */
export const TYPE_ROLES = ["display", "title", "heading", "body", "small", "caption", "eyebrow"] as const;
/** Body and caption on a tighter line, for the dense controls inside components/ui only (globals.css). */
export const TIGHT_ROLES = ["body-tight", "caption-tight"] as const;

const twMerge = extendTailwindMerge({
  extend: { theme: { text: [...TYPE_ROLES, ...TIGHT_ROLES] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
